import React from 'react';

const Text = ({ 
    children, 
    tag = 'span', 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    const Tag = tag;
    
    return (
        <Tag className={className} style={style} {...props}>
            {children}
        </Tag>
    );
};

export default Text;

